function About() {
  return (
    <section className="mb-5">
      <h3>About Me</h3>
      <p>
        I’m a career switcher with a strong background in customer service and
        education. I bring excellent communication skills and a user-first
        mindset into front-end development.
      </p>
      <p>📍 United Kingdom · Open to remote work</p>
    </section>
  );
}

export default About;
